import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import MenuSection from "./components/MenuSection";
import ReviewsSection from "./components/ReviewsSection";
import GallerySection from "./components/GallerySection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import { translations, menuCategories, customerReviews, galleryImages } from "./mockData";

const Home = () => {
  const [currentLang, setCurrentLang] = useState('tr');

  const t = translations[currentLang];
  const menu = menuCategories[currentLang];
  const reviews = customerReviews[currentLang];

  const handleLanguageChange = (lang) => {
    setCurrentLang(lang);
  };

  return (
    <div className="min-h-screen">
      <Header translations={t} currentLang={currentLang} onLanguageChange={handleLanguageChange} />
      <HeroSection translations={t} />
      <AboutSection translations={t} />
      <MenuSection translations={t} menuCategories={menu} />
      <ReviewsSection translations={t} reviews={reviews} />
      <GallerySection translations={t} images={galleryImages} />
      <ContactSection translations={t} currentLang={currentLang} />
      <Footer translations={t} currentLang={currentLang} />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
